// Percentage is only the operator's input. Checkout continues sending integer
// centavos through the existing discount_cents contract and server-side guard.
export function discountPercentValue(value) {
  const number=Number(String(value??0).replace(',','.'));
  if(!Number.isFinite(number))return 0;
  return Math.max(0,Math.min(100,Math.round(number*100)/100));
}
export function discountCentsFromPercent(grossCents,percent) {
  const gross=Math.max(0,Math.round(Number(grossCents)||0));
  return Math.min(gross,Math.round(gross*discountPercentValue(percent)/100));
}
export function percentFromDiscountCents(grossCents,discountCents) {
  const gross=Number(grossCents)||0;
  if(gross<=0)return 0;
  const cents=Math.max(0,Number(discountCents)||0);
  return discountPercentValue((100*cents)/gross);
}
